import { Button, Grid, IconButton, Tooltip } from "@material-ui/core";
import { columnDateField, columnTextField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { Add, Delete, Download, Visibility } from "@mui/icons-material";

export default function TableActions({
  data,
  totalRegistros,
  page,
  sizePerPage,
  onTableChange,
  onAction,
  onView,
  onDelete,
  onCreate,
  isClient,
}) {
  const columnModel = [
    columnTextField(
      {
        dataField: "Periodo",
        text: "Período",
        headerAlign: "left",
      },
      false
    ),
    columnTextField(
      {
        dataField: "NomeArquivo",
        text: "Nome do Arquivo",
        headerAlign: "left",
      },
      false
    ),
    !isClient &&
      columnDateField(
        {
          dataField: "DataInclusao",
          text: "Data de Criação",
          headerAlign: "center",
          align: "center",
        },
        false
      ),
    !isClient &&
      columnTextField(
        {
          dataField: "CriadoPor",
          text: "Criado por",
          headerAlign: "center",
          align: "center",
        },
        false
      ),
    columnTextField({
      dataField: "acoes",
      text: "Ações",
      align: "center",
      formatter: (_, row) => {
        return (
          <Grid container spacing={2}>
            <Grid item xs={isClient ? 6 : 4}>
              <Tooltip title="Visualizar Arquivo">
                <IconButton
                  color="primary"
                  onClick={() => {
                    console.log("Abrindo preview - URL:", row.UrlArquivo);
                    console.log("Dados da linha completa:", row);
                    onView(row.UrlArquivo);
                  }}
                  size="small"
                  style={{ cursor: "pointer" }}
                >
                  <Visibility fontSize="small" color="textPrimary" />
                </IconButton>
              </Tooltip>
            </Grid>

            <Grid item xs={isClient ? 6 : 4}>
              <Tooltip title="Baixar Arquivo">
                <IconButton
                  color="primary"
                  onClick={() => onAction(row.UrlArquivo)}
                  size="small"
                  style={{ cursor: "pointer" }}
                >
                  <Download fontSize="small" color="textPrimary" />
                </IconButton>
              </Tooltip>
            </Grid>

            {!isClient && (
              <Grid item xs={4}>
                <Tooltip title="Excluir Arquivo">
                  <IconButton
                    color="primary"
                    onClick={() => onDelete(row)}
                    size="small"
                    style={{ cursor: "pointer" }}
                  >
                    <Delete fontSize="small" color="textPrimary" />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        );
      },
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data}
      headerTitle="Ações de Marketing Realizadas"
      searched={Boolean(data)}
      keyField={"IdFranquiaFundoPropaganda"}
      columnModel={columnModel}
      notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
      pagination={{
        options: [10, 25, 50],
        totalSize: totalRegistros,
        page: page + 1,
        sizePerPage: sizePerPage,
        showTotal: true,
      }}
      bootstrapTableProps={{
        remote: true,
        onTableChange: onTableChange,
      }}
      extraActions={
        !isClient && (
          <Button variant="contained" color="primary" onClick={onCreate}>
            <Add /> Criar Ação
          </Button>
        )
      }
    />
  );
}
